export const baseFonts = [
  {
    name: 'HarmonyOS_Sans_Regular',
    fontFamily: 'HarmonyOS_Sans_Regular',
    value: 'HarmonyOS_Sans_Regular',
    label: 'HarmonyOS_Sans_Regular',
  },
  {
    name: 'HarmonyOS_Sans_SC_Regular',
    fontFamily: 'HarmonyOS_Sans_SC_Regular',
    value: 'HarmonyOS_Sans_SC_Regular',
    label: 'HarmonyOS_Sans_SC_Regular',
  },
  {
    name: 'HarmonyOS_Sans_SC_Medium',
    fontFamily: 'HarmonyOS_Sans_SC_Medium',
    value: 'HarmonyOS_Sans_SC_Medium',
    label: 'HarmonyOS_Sans_SC_Medium',
  },
  {
    name: 'YPchuangxiang1.20',
    fontFamily: 'YPchuangxiang1.20',
    value: 'YPchuangxiang1.20',
    label: 'YPchuangxiang1.20',
  },
  {
    name: 'Kingsoft_Cloud_Font',
    fontFamily: 'Kingsoft_Cloud_Font',
    value: 'Kingsoft_Cloud_Font',
    label: 'Kingsoft_Cloud_Font',
  },
];

export const additionalFonts = [
  {
    name: 'SourceHanSansSC-Bold',
    fontFamily: 'SourceHanSansSC-Bold',
    value: 'SourceHanSansSC-Bold',
    label: 'SourceHanSansSC-Bold',
  },
  {
    name: 'SourceHanSansSC-Medium',
    fontFamily: 'SourceHanSansSC-Medium',
    value: 'SourceHanSansSC-Medium',
    label: 'SourceHanSansSC-Medium',
  },
  {
    name: 'din-2014_bold-italic',
    fontFamily: 'din-2014_bold-italic',
    value: 'din-2014_bold-italic',
    label: 'din-2014_bold-italic',
  },
  {
    name: 'NIU-ACCESSARY-Regular',
    fontFamily: 'NIU-ACCESSARY-Regular',
    value: 'NIU-ACCESSARY-Regular',
    label: 'NIU-ACCESSARY-Regular',
  },
  {
    name: 'NIU-Digital-Regular',
    fontFamily: 'NIU-Digital-Regular',
    value: 'NIU-Digital-Regular',
    label: 'NIU-Digital-Regular',
  },
];

const loadAdditionalFonts = import.meta.env.APP_LOAD_NIU_FONTS === 'true';

export const fontList = loadAdditionalFonts ? [...baseFonts, ...additionalFonts] : [...baseFonts];

export const fontFamilies = fontList.map((font) => font.fontFamily);

export default fontList;
